import { Box, IconButton, Popover } from "@mui/material";
import TypographyCompo from "./TypographyCompo";
import { slightBluishTintColor } from "../../config/ColorObj";

const MultiSelectPopover = ({
    open,
    anchorEl,
    onClose,
    items = [],
    onRemove,
    emptyText = "No items selected",
    minWidth = 260,
    anchorOrigin = { vertical: "bottom", horizontal: "right" },
    transformOrigin = { vertical: "top", horizontal: "left" },
}) => {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            disablePortal
            PaperProps={{
                sx: {
                    mt: 0.1,
                    ml: -1,
                    minWidth,
                },
            }}
        >
            <Box sx={{ p: 2 }}>
                {items.length === 0 ? (
                    <TypographyCompo sx={{ fontSize: 13, color: slightBluishTintColor }}>
                        {emptyText}
                    </TypographyCompo>
                ) : (
                    items.map((item) => (
                        <Box
                            key={item.id}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <TypographyCompo sx={{ fontSize: 13 }}>
                                {item.name}
                            </TypographyCompo>

                            <IconButton
                                size="small"
                                color="error"
                                onClick={() => onRemove(item)}
                            >
                                ✕
                            </IconButton>
                        </Box>
                    ))
                )}
            </Box>
        </Popover>
    );
};

export default MultiSelectPopover;
